// extracted by mini-css-extract-plugin
module.exports = {"fontStack":"Signature_fontStack_39fmf","signatureWrapper":"Signature_signatureWrapper_3bz9C"};